'use client';

import React from 'react';

import ProductConfiguration from '@storefront/app/v2/pdp-config/printer/product-configuration/product-configuration';

import OrderDetails from '../order-details/order-details';

export default function ConfigurationWrapper() {
  return (
    <>
      <ProductConfiguration />
      <OrderDetails />
    </>
  );
}
